<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <!--<button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>-->
            <button [disabled]="!habilitarGuardar" class="btn btn-outline-success" type="button" title="Nuevo Documento" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Documento</button>

        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4 style="display:inline">Documentos {{solicitudDocumento.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />-->
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{solicitudDocumento.CodigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudDocumento.IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{solicitudDocumento.IdEstadoSolicitudDescripcion}}" />
                <img *ngIf="solicitudDocumento.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{solicitudDocumento.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{solicitudDocumento.IdEstadoChedPpDescripcion}}" />
                <img *ngIf="solicitudDocumento.IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{solicitudDocumento.IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudDocumento.DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                <img class="predua-icono-big" container="body" ngbTooltip="{{solicitudDocumento.EsPredua | preduaNoPredua}}" src="{{solicitudDocumento.EsPredua | IconoPreduaSolicitud}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="id">
                    <app-alertarechazo [id]="id" [esImport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success">

                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Documentos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="solicitudDocumento.TDocumentoSolicitudCollection"
                                 [columns]="cols" sortField="Fecha" sortOrder="-1"
                                 styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                 [ngClass]="displayGridHidden(solicitudDocumento.TDocumentoSolicitudCollection)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">
                                            {{rowData[col.field]}}
                                        </span>
                                        <span *ngIf="col.field==='Fecha'">
                                            {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                        </span>


                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                            <div>
                                                <button *ngIf="isDocumentoDescargable(rowData)" (click)="onDownload(rowData)" type="button" title="Descargar documento"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-download"></span>
                                                </button>
                                                <span *ngIf="!isDocumentoDescargable(rowData)" style="margin-left:1px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                            </div>

                                            <div *ngIf="documentoEditable && ((!EsInspector && !rowData['SubidoPorInspector']) || EsInspector)">
                                                <button [disabled]="solicitudDocumento.IdEstadoSolicitud === rechazadaParcialmente" (click)="onEdit(rowData)" type="button" title="Editar"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-edit"></span>

                                                </button>
                                            </div>
                                            <div *ngIf="!documentoEditable || (!EsInspector && rowData['SubidoPorInspector'])">
                                                <button [disabled]="solicitudDocumento.IdEstadoSolicitud === rechazadaParcialmente" (click)="onEdit(rowData)" type="button" title="Ver"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-search"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="documentoBorrable">
                                                <button [disabled]="(rowData['Revisado'] || rowData['SubidoPorInspector'] || solicitudDocumento.IdEstadoSolicitud === rechazadaParcialmente) && !EsInspector" (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="rowData['Revisado']">
                                                <button [disabled]="!EsInspector || solicitudDocumento.IdEstadoSolicitud === rechazadaParcialmente" (click)="marcaRevisado(rowData,false)" type="button" title="Marcar como No Revisado"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-check"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="!rowData['Revisado'] && EsInspector">
                                                <button [disabled]="solicitudDocumento.IdEstadoSolicitud === rechazadaParcialmente" (click)="marcaRevisado(rowData,true)" type="button" title="Marcar como Revisado"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-file"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="rowData['DeRechazoParcial']">
                                                <img class="icono-info-grid-med" src="./assets/images/DeRechazoParcial.png" container="body" ngbTooltip="Este documento se hereda de otra solicitud. Consulte los enlaces de la cabecera." />
                                            </div>

                                        </div>

                                        <span *ngIf="col.field==='Link' && isTracesInfoVisible(rowData)">
                                            <img class="estado-icono" src="{{ (rowData['ReferenciaTraces'] | IconoDocumentoTraces)[0]}}" container="body" ngbTooltip="{{ (rowData['ReferenciaTraces'] | IconoDocumentoTraces)[1]}}" />
                                        </span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                            <button *ngIf="isUploadTracesVisible(rowData)" (click)="onUploadTraces(rowData)" type="button" title="Subir Documento a Traces" class="btn btn-sm btn-info">
                                                <span class="fa fa-paper-plane"></span>
                                            </button>

                                            <button *ngIf="visibilitySpinnerUploadTraces && rowData.Id === idRowOnUploadTraces" disabled type="button" class="btn  btn-sm btn-info" title="Subiendo Documento a Traces">
                                                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>

                                            </button>

                                        </div>


                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>
                        <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                            No hay documentos asociados a la solicitud
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
